module.exports = __webpack_public_path__ + "img/header-icon.bfa9f2b3.svg";